import  { FC, Fragment } from 'react'
import DataRow from './DataRow'
import { useTranslation } from 'react-i18next'

interface IDynamisServiceCard {
  data: any,
  setData: Function,
  fieldName: string
}

const DynamisServiceCard: FC<IDynamisServiceCard> = ({ data, setData }) => {

  const { t } = useTranslation()

  const handleChange = (data: any[]) => {
    setData((prev: any) => ([...data]))
  }

  const handleAddRow = () => {
    setData((prev: any) => ([...prev, { diseaseName: null, notes: "" }]))

  }

  return (
    <div>
      <div className='alert'>{t(`add-note`)}</div>
      {
        //@ts-ignore
        data.map((item: any, index: number) => (
          <Fragment>
            <DataRow setData={(data: any) => handleChange(data)} data={data} index={index} onDelete={(data: any) => handleChange(data)} />
          </Fragment>
        ))
      }
      <div className='alert pointer' onClick={handleAddRow}>
        {t("add-another")}  +
      </div>
    </div>
  )
}

export default DynamisServiceCard